import Icon from '@components/common/Icon';
import ImageCard from '@components/common/ImageCard';
import { getDataUrl } from '@lib/utils';

const HeroSection = () => {
  const stats = [
    { label: 'Elo Peak Rating', value: '2600+' },
    { label: 'Tournaments', value: '50+' },
    { label: 'National Titles', value: '3x' },
    { label: 'Top Lichess Ranking', value: '0.1%' }
  ];

  return (
    <section className="relative overflow-hidden py-16 sm:py-20 lg:py-32 px-4 sm:px-6 lg:px-8">
      {/* Gradient background with chess theme */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, var(--color-theme-1), var(--color-theme-2))'
        }}
      >
        {/* Ambient shapes */}
        <div
          className="absolute top-0 right-1/4 w-96 h-96 rounded-full mix-blend-multiply filter blur-3xl opacity-20"
          style={{ backgroundColor: 'var(--color-accent-3)' }}
        ></div>
        <div
          className="absolute bottom-0 left-1/3 w-80 h-80 rounded-full mix-blend-multiply filter blur-3xl opacity-15"
          style={{ backgroundColor: 'var(--color-accent-4)' }}
        ></div>
      </div>

      <div className="container mx-auto relative z-10 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Hero Content */}
          <div className="space-y-8 text-left">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full" style={{ backgroundColor: 'var(--color-theme-2)', borderColor: 'var(--color-border-light)', borderWidth: '1px', borderStyle: 'solid' }}>
              <Icon name="chess" size="md" style={{ color: 'var(--color-accent-6)' }} />
              <span className="text-sm font-semibold" style={{ color: 'var(--color-accent-6)' }}>
                National Master
              </span>
            </div>

            {/* Title */}
            <div className="space-y-4">
              <h1
                className="text-4xl sm:text-5xl lg:text-7xl font-heading font-extrabold tracking-tight"
                style={{ color: 'var(--color-heading)' }}
              >
                Chess Excellence
              </h1>
              <p
                className="text-lg sm:text-xl lg:text-2xl font-semibold"
                style={{ color: 'var(--color-subheading)' }}
              >
                National Master & Three-Time National Champion
              </p>
            </div>

            {/* Description */}
            <p
              className="text-base sm:text-lg leading-relaxed max-w-2xl"
              style={{ color: 'var(--color-subtle)' }}
            >
              From winning national championships to earning the prestigious National Master title,
              my chess journey reflects dedication, strategic thinking, and a passion for the game.
              Beyond competition, I use chess as a tool for social impact, mentoring inmates and
              underprivileged youth.
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 pt-4">
              {stats.map((stat, index) => (
                <div key={index} className="text-left">
                  <div
                    className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-1"
                    style={{ color: 'var(--color-accent-6)' }}
                  >
                    {stat.value}
                  </div>
                  <div
                    className="text-xs sm:text-sm font-medium"
                    style={{ color: 'var(--color-muted)' }}
                  >
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Featured Image */}
          <div className="flex justify-center">
            <div className="relative max-w-lg w-full">
              <div
                className="rounded-2xl overflow-hidden shadow-card-hover"
                style={{
                  backgroundColor: 'var(--color-card-bg)',
                  borderColor: 'var(--color-border-light)',
                  borderWidth: '1px',
                  borderStyle: 'solid'
                }}
              >
                <ImageCard
                  src={getDataUrl('chess/achievements/trophies_and_medals_collage.webp')}
                  alt="Chess Trophies and Medals Collection"
                  aspectRatio="aspect-square"
                  rounded={false}
                  className="w-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
